import { render, staticRenderFns } from "./DividerPage.vue?vue&type=template&id=eb476514"
import script from "./DividerPage.vue?vue&type=script&lang=ts"
export * from "./DividerPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports